<script setup lang="ts">
/* Stores */
import { useBasketStore } from '@/store/basket/basket'
import { useBasketChangeStore } from '@/store/basket/basket-change'

/* Components */
import basketDropdownIcon from '@/components/Icons/IconArrowBottom.vue'

type Props = {
  change: number
}
defineProps<Props>()

const basketStore = useBasketStore()
const basketChangeStore = useBasketChangeStore()

const setSelectedChange = (currentChange: number) => {
  basketStore.setChange(currentChange)
}

const changeList = computed(() => {
  return basketChangeStore.choices
})
</script>

<template>
  <div class="change">
    <v-select
      :model-value="change"
      :items="changeList"
      item-title="text"
      item-value="value"
      :menu-icon="basketDropdownIcon"
      variant="solo"
      hide-details
      :menu-props="{
        contentClass: 'basket-change-menu',
      }"
      @update:model-value="setSelectedChange"
    />
  </div>
</template>

<style lang="scss">
.basket-change-menu {
  .v-list-item {
    min-height: 40px !important;

    &--active {
      color: $primary !important;
    }

    &-title {
      font-size: 0.8125rem !important;
      font-weight: 500 !important;
    }
  }
}
</style>

<style lang="scss" scoped>
.change {
  width: 130px;
  :deep() {
    .v-field {
      margin-bottom: 0 !important;
      font-size: 12px;
      font-weight: 600;
      line-height: 18px;
      background-color: $button-background;
      border-radius: 6px;
      box-shadow: none !important;
      @include media('>=desktop-mini') {
        min-height: 38px;
      }
    }

    .v-field__input {
      align-items: center;
      min-height: 38px;
      padding: 0;
      padding-left: 12px;
    }

    .v-field__append-inner {
      align-items: center;
      padding: 0;
    }
  }
}
</style>
